import { useLayoutEffect, useState } from "react"

// スクロールバー幅を取得
export const useScrollbarWidthSizeFunc = () => {
  useLayoutEffect(() => {
    const setScrollbarWidthSize = () => {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth
      document.documentElement.style.setProperty(
        "--scrollbar",
        `${scrollbarWidth}px`
      )
    }
    window.addEventListener("resize", setScrollbarWidthSize)
    setScrollbarWidthSize()
    return () => window.removeEventListener("resize", setScrollbarWidthSize)
  }, [])
}

// ウィンドウ幅を取得
export const useWindowWidthSizeFunc = () => {
  const [windowWidthSize, setWindowWidthSize] = useState(0)
  useLayoutEffect(() => {
    const updateWindowWidthSize = () => {
      setWindowWidthSize(window.innerWidth)
    }
    window.addEventListener("resize", updateWindowWidthSize)
    updateWindowWidthSize()
    return () => window.removeEventListener("resize", updateWindowWidthSize)
  }, [])
  return windowWidthSize
}
